import { NavLink } from "react-router-dom";
import { House, ListChecks, PlusCircle, ChartBar, Users } from "@phosphor-icons/react";

const NAV_BY_ROLE = {
  requester: [
    { to: "/", icon: House, label: "Home", end: true, testid: "bnav-home" },
    { to: "/queue", icon: ListChecks, label: "Queue", testid: "bnav-queue" },
    { to: "/new", icon: PlusCircle, label: "New", testid: "bnav-new", primary: true },
    { to: "/reports", icon: ChartBar, label: "Reports", testid: "bnav-reports" },
    { to: "/admin", icon: Users, label: "Settings", testid: "bnav-admin" },
  ],
  auditor: [
    { to: "/", icon: House, label: "Home", end: true, testid: "bnav-home" },
    { to: "/queue", icon: ListChecks, label: "Audit", testid: "bnav-queue" },
    { to: "/reports", icon: ChartBar, label: "Reports", testid: "bnav-reports" },
  ],
  payer: [
    { to: "/", icon: House, label: "Home", end: true, testid: "bnav-home" },
    { to: "/queue", icon: ListChecks, label: "Payments", testid: "bnav-queue" },
  ],
  approver: [
    { to: "/", icon: House, label: "Home", end: true, testid: "bnav-home" },
    { to: "/queue", icon: ListChecks, label: "Approve", testid: "bnav-queue" },
  ],
  admin: [
    { to: "/", icon: House, label: "Home", end: true, testid: "bnav-home" },
    { to: "/queue", icon: ListChecks, label: "Queue", testid: "bnav-queue" },
    { to: "/new", icon: PlusCircle, label: "New", testid: "bnav-new", primary: true },
    { to: "/reports", icon: ChartBar, label: "Reports", testid: "bnav-reports" },
    { to: "/admin", icon: Users, label: "Admin", testid: "bnav-admin" },
  ],
};

export default function BottomNav({ role }) {
  const items = NAV_BY_ROLE[role] || NAV_BY_ROLE.requester;
  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-white/50 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]"
    >
      <div className="flex items-stretch justify-around px-1 py-1.5">
        {items.map(({ to, icon: Icon, label, end, testid, primary }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 flex-1 min-w-0 py-1.5 rounded-xl transition-colors ${
                isActive
                  ? "text-amber-700 font-semibold"
                  : "text-slate-600 hover:text-slate-900"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all ${
                    primary
                      ? "chrome shadow-md -mt-3 shimmer-border w-11 h-11"
                      : isActive
                        ? "bg-amber-100"
                        : ""
                  }`}
                >
                  <Icon
                    size={primary ? 22 : 20}
                    weight={isActive || primary ? "fill" : "duotone"}
                    className={primary ? "text-amber-600" : ""}
                  />
                </div>
                <span className="text-[10px] leading-tight truncate max-w-[64px]">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
